import {
  ContentServiceStoryHeadlines,
  DaperStory,
  DaperStoryHeadlines,
  DaperStorySearchParams,
} from "@foundation/intercom-client";
import { decode } from "ent";
import { hydrateModel } from "@foundation/hydrate-model";
import intercom from "~config/intercom";
import type { ArticleRecircStory, Image } from "~types/types";
import { storyImageFromDaperModel } from "~models/StoryImageFromDaper.model";

type StoryFromDaperWithImage = DaperStory & {
  image?: Omit<Image, "url"> & { src: string };
  headline: string;
};

type DaperStoryImage = Omit<Image, "url"> & {
  src: string;
};

const getHeadlineMarkup = ({
  headlines,
}: {
  headlines: DaperStoryHeadlines | ContentServiceStoryHeadlines;
}) => {
  const { markup, web } = headlines;

  if (markup?.web) return markup.web;

  return web;
};

const getHeadline = ({
  headlines,
}: {
  headlines: DaperStoryHeadlines | ContentServiceStoryHeadlines;
}) => {
  const html = getHeadlineMarkup({ headlines });

  return decode(html.replace(/<[^>]*>?/g, ""));
};

export const fetchStoriesWithImageFromDaper = async (
  params: DaperStorySearchParams
): Promise<ArticleRecircStory[]> => {
  const stories = await intercom.getStories(params);

  const imageIds = stories.reduce<string[]>((ids, story) => {
    const id = story.extraMedia?.thumbnail?.default.id;

    if (id) ids.push(id);

    return ids;
  }, []);

  const images = await intercom.getImagesBulk({ imageIds });

  return stories.map((story: DaperStory) => {
    const image = images[story.extraMedia?.thumbnail?.default.id as string];

    const { model: hydratedStoryImage } = hydrateModel(
      image,
      storyImageFromDaperModel
    );

    return {
      ...story,
      image: image?.baseUrl
        ? (hydratedStoryImage as DaperStoryImage)
        : undefined,
      headline: getHeadline({ headlines: story.headlines }),
    };
  });
};
